import { useMemo } from 'react'
import useWallet from '@/utils/hooks/useWallet'
import isAlkanes from '@/utils/is-alkanes'
import useAlkanesOutpoints from '@/utils/hooks/useAlkanesOutpoints'
import isRune from '@/utils/is-rune'
import useRuneOutpoints from '@/utils/hooks/useRuneOutpoints'
import { selectTokenOutpoints } from './select-token-outpoints'

export default function useTokenOutpoints(
	token: any,
	address?: string
): {
	data: any[]
	isLoading: boolean
} {
	const slug = token?.collection?.slug || token?.slug
	const objectMemberIds = useMemo(() => {
		const ids = token?.collection_object_member_ids || token?.memberIds || token?.member_ids
		return Array.isArray(ids) ? new Set(ids.filter(Boolean)) : null
	}, [token])
	const runeOutpoints = useRuneOutpoints(token?.rune_id, address)
	const alkaneOutpoints = useAlkanesOutpoints(token?.rune_id, address)
	const { data, isLoading } = useWallet()

	const transfers = useMemo(
		() => selectTokenOutpoints(data?.inscriptions, slug, objectMemberIds),
		[data, slug, objectMemberIds]
	)

	if (!token) {
		return { data: [], isLoading: false }
	}

	if (isRune(slug)) {
		return runeOutpoints
	}

	if (isAlkanes(slug)) {
		return alkaneOutpoints
	}

	return { data: transfers, isLoading }
}
